// اضافه کردن کتابخانه ها به صفحه
import * as React from 'react'
import ParsiMap from "./parsiMap";
import Neshan from "./neshan";
import {useSnackbar} from "notistack";
import {setLoading} from "../../redux/loading/actions";
import HandleFetchData from "../../plugin/HandleFetchData";


var neshanToken = {
    headers: {
        // 'Api-Key': 'service.8c667d9069564606b33ad1074e71dc40'
        'Api-Key': 'service.7fa7c6e9ba464dc6ac11932cb47f0b3e'
    },
};

function SimpleMap(props) {
    const {enqueueSnackbar} = useSnackbar();
    const {fetchData} = HandleFetchData()

    const mapRef = React.useRef(null)

    // متغیر و useState های لوکال صفحه
    const [lng, setLng] = React.useState(51.4);
    const [lat, setLat] = React.useState(35.7);
    const [zoom, setZoom] = React.useState(10);
    const [mapObject, setMapObject] = React.useState()
    const [parsiMap, setParsiMap] = React.useState(true)

    // let state = props?.searchInMap?.split('-')[0]
    // let city = props?.searchInMap?.split('-')[1]


    // React.useEffect(() => {
    //     // // let state = props?.searchInMap?.split('-')[0]
    //     // // let city = props?.searchInMap?.split('-')[1]
    //     // // state && handlerSearchWithAddressInParsiMap('استان' + ' ' + state + ' شهر' + ' ' + city)
    //     //
    //     // handlerSearchWithAddressInParsiMap(props?.searchInMap)
    // }, [props?.searchInMap]);

    // React.useEffect(() => {
    //     if (parsiMap) {
    //         fetch(`https://api.parsimap.ir/styles/parsimap-streets-v11?key=p1a17b4952e44846b5a486861f1f7c9153c49fdb24`).then((response) => response).then((data) => {
    //             setParsiMap(data.ok)
    //         }).catch((e) => console.log('error', e))
    //     }
    // }, [parsiMap])


    React.useEffect(() => {
        mapRef.current?.flyTo({center: [props?.lngToMap, props?.latToMap]})
    }, [props?.latToMap])


    const handleError = (error) => {
        console.error('An error occurred:', error);
    };

    const setLngLat = (e) => {
        if((e?.latitude || e?.lat) && (e?.longitude || e?.lng)){
            setLng(e?.longitude || e?.lng || "")
            setLat(e?.latitude || e?.lat || "")
            props.handlerLngFromMap(e?.longitude || e?.lng || "")
            props.handlerLatFromMap(e?.latitude || e?.lat || "")
        }
    }


    const handlerSearchWithLocation = async (lng, lat, type) => {
        await handleSearchAddress(lng, lat)
    }


    const handleSearchAddress = async (lng, lat) => {
        let fetch = await fetchData('locationservice', 'GET', `/Map/reverse_address`, '', "application/json", {
            "latitude": lat,
            "longitude": lng
        }, 'postex')
        props.handlerAddressFromMap(fetch?.address)
    }

    const handleSearchLocation = async (e) => {
        let fetch = await fetchData('locationservice', 'GET', `/Map/search`, '', "application/json", {
            "Keyword": e
        }, 'postex')
        setLngLat(fetch || null)
        mapObject?.flyTo([fetch?.latitude, fetch?.longitude], zoom)
        // console.log('handleSearchLocation', fetch)
    }

    return (
        <>
            <div className="simple-map">

                {
                    parsiMap ?
                        <ParsiMap
                            lngToMap={props.lngToMap || lng}
                            latToMap={props.latToMap || lat}
                            coordinates={props.coordinates}
                            zoom={props.zoom || zoom}
                            setLngLat={(event) => setLngLat(event)}
                            handlerSearchWithLocation={(event1, event2) => {
                                setTimeout(() => {
                                    handlerSearchWithLocation(event1, event2, "parsimap")
                                }, 1000)
                            }}
                            handleError={(event) => handleError(event)}
                            handleZoom={(event) => setZoom(event)}
                            agent={props.agent}
                            handleSearchAddress={(event) => handleSearchLocation(event)}
                        />
                        :
                        <Neshan
                            mapRef={mapRef}
                            lngToMap={props.lngToMap || lng}
                            latToMap={props.latToMap || lat}
                            coordinates={props.coordinates}
                            zoom={props.zoom || zoom}
                            mapObject={mapObject}
                            setLngLat={(event) => setLngLat(event)}
                            setMapObject={(event) => setMapObject(event)}
                            handlerSearchWithLocation={(event1, event2) => {
                                setTimeout(() => {
                                    handlerSearchWithLocation(event1, event2, "neshan")
                                }, 1000)
                            }}
                            handleError={(event) => handleError(event)}
                            handleZoom={(event) => setZoom(event)}
                            agent={props.agent}
                            handleSearchAddress={(event) => handleSearchLocation(event)}
                        />
                }


                {/*{*/}
                {/*  props?.showSearchInMap &&*/}
                {/*  <div className="map-search">*/}
                {/*    <Autocomplete*/}
                {/*       inputValue={addressText}*/}
                {/*       id="free-solo-demo"*/}
                {/*       noOptionsText={t("autoComplete.t1")}*/}
                {/*       freeSolo*/}
                {/*       autoHighlight*/}
                {/*       filterSelectedOptions*/}
                {/*       onChange={(e, value) => {*/}
                {/*         setLngLat({*/}
                {/*              lngLat: {*/}
                {/*                lng: value?.geo_location?.center?.lng,*/}
                {/*                lat: value?.geo_location?.center?.lat*/}
                {/*              }*/}
                {/*            }*/}
                {/*         )*/}
                {/*       }}*/}
                {/*       options={addressList}*/}
                {/*       getOptionLabel={(option) => option?.description}*/}
                {/*       renderInput={*/}
                {/*         (params) => <TextField*/}
                {/*            {...params}*/}
                {/*            hiddenLabel*/}
                {/*            size="small"*/}
                {/*            placeholder={t("map.t1")}*/}
                {/*            onChange={event => handlerSearchWithAddressInParsiMap(event?.target?.value)}/>*/}
                {/*       }*/}
                {/*    />*/}
                {/*  </div>*/}
                {/*}*/}
            </div>
        </>
    );
}


export default SimpleMap;
